<template>
    <div>
<!--        <app-header :cur="1"></app-header>-->
        <router-view></router-view>
        <div class="ajaxLoadDiv"
             id="bottom"></div>
    </div>
</template>

<script>
    import Header from '../header';
    import Footer from '../footer';
    export default {
        data() {
            return {
            };
        },
        components: {
            'app-header': Header,
            'app-footer': Footer,
        },
        methods: {
        }
    };
</script>
